import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export var PageLoading = function () {
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "page-loading", children: _jsx("div", { className: "sp-circle" }) }) }));
};
